import { useParams, useSearchParams } from "react-router-dom";
import SeekingCurators from "../../components/SeekingCurators/SeekingCurators";

export default function SeekingCuratorsPage() {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const topic = searchParams.get("topic");

    return (
        <SeekingCurators collectionId={id} topic={topic} />
    );
} 